import { useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { Typography, Box } from "@mui/material"
import { useEffect, useState } from "react"
import { pageTitleSx, rootSx } from "./styled"
import UIIcon from "../UIIcon"
import { ROUTES, ROUTES_PATHS } from "../../utils/constants"
import {
  resetSteps,
  setPreviousStep,
} from "../../store/slices/routingSlice/routingSlice"
import { RootState } from "../../store/store"
import { TFlowName } from "../../store/slices/routingSlice/types"
import { sendCustomEvent } from "../../events/events"

function formatPath(path: string) {
  return path.replace(/\/$/, "").toLowerCase()
}

function getCurrentRouteConfig(pathname: string) {
  const routeConfig = ROUTES.find(
    (route) => formatPath(route.path) === formatPath(pathname),
  )

  return routeConfig
}

const handleQuitEvent = () => {
  sendCustomEvent({
    eventName: "quit",
  })
}

const Header = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const [isApplicationEntryPoint, setIsApplicationEntryPoint] = useState(false)
  const [prevPath, setPrevPath] = useState("")
  const currentFlow = useSelector(
    (state: RootState) =>
      state.routing.routes[state.routing.currentFlow as TFlowName],
  )
  const customBackHandler = useSelector(
    (state: RootState) => state.header.customBackHandler,
  )

  useEffect(() => {
    if (location.key === "default") {
      setIsApplicationEntryPoint(true)
    }
    if (location.key !== "default" && location.pathname !== "/auth") {
      if (prevPath !== "/auth") {
        setIsApplicationEntryPoint(false)
      }
    }
  }, [location])

  useEffect(() => {
    setPrevPath(location.pathname)
  }, [location])

  const currentRoute = getCurrentRouteConfig(location.pathname)

  const titleFromState = currentFlow?.steps[currentFlow?.currentStep]?.title
  const hideFromState = currentFlow?.steps[currentFlow?.currentStep]?.hideNavBar

  const pageTitle = titleFromState || currentRoute?.title || ""
  const hideNavBar = currentRoute?.shouldHideNavBar || hideFromState
  const isntInFlow =
    currentFlow === undefined ||
    currentFlow?.currentStep === "" ||
    currentFlow?.steps[currentFlow?.currentStep]?.previousStep === ""

  const isHomePage = currentRoute?.path === "/main"
  const isDetailsPage = location.pathname.includes("details")
  const isBeelineHistoryPage = currentRoute?.path === "/history-beeline"
  const isOperationsHistoryPage = currentRoute?.path === "/operations-history"
  const shouldShowProfileIcon = isBeelineHistoryPage || isOperationsHistoryPage

  const handleClickPrevious = () => {
    if (customBackHandler) {
      customBackHandler(location.pathname)
      return
    }
    
    if (isApplicationEntryPoint) {
      navigate("/quit")
      return
    }
    if (isHomePage) {
      handleQuitEvent()
    }
    if (!isntInFlow) {
      dispatch(setPreviousStep())
    } else if (currentRoute?.prevPage) {
      navigate(currentRoute.prevPage)
      dispatch(resetSteps())
    } else {
      navigate(-1)
      dispatch(resetSteps())
    }
  }

  if (!hideNavBar && !isDetailsPage) {
    return (
      <Box sx={rootSx}>
        {shouldShowProfileIcon ? (
          <UIIcon iconName="beelineProfile" onClick={handleClickPrevious} />
        ) : (
          <UIIcon iconName="arrowBack" onClick={handleClickPrevious} />
        )}
        <Typography component="div" sx={pageTitleSx}>
          {pageTitle}
        </Typography>

        {isHomePage && (
          <UIIcon
            iconName="settingsIcon"
            onClick={() => navigate(`${ROUTES_PATHS.settings}`)}
          />
        )}
      </Box>
    )
  }

  return <Box sx={rootSx} />
}

export default Header
